import { render, staticRenderFns } from "./changePhoneNumber.vue?vue&type=template&id=2f5746aa&"
import script from "./changePhoneNumber.vue?vue&type=script&lang=js&"
export * from "./changePhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./changePhoneNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports